import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  :root {
    --primary-color: #0056b3;
    --secondary-color: #003366;
    --accent-color: #ffc107;
    --light-color: #f8f9fa;
    --dark-color: #212529;
    --text-color: #333;
    --shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }
  
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  }
  
  body {
    line-height: 1.6;
    color: var(--text-color);
    background-color: #f5f5f5;
  }
  
  .container {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 15px;
  }
  
  /* Include the rest of your CSS styles here */
  /* ... */
`;

export default GlobalStyles;